import type { IconData } from '@stacksjs/iconify-core'

export const co1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#ffe800\" d=\"M0 0h512v512H0z\"/><path fill=\"#00148e\" d=\"M0 256h512v256H0z\"/><path fill=\"#da0010\" d=\"M0 384h512v128H0z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default co1x1
